import { Auth } from 'aws-amplify';
import { redirect } from 'react-router';

import { ACCOUNT_QUERY_KEY, accountQueryFn } from 'api/queries/useAccountQuery';
import { getIsProduction } from 'utils';
import { trackExistingUserRedirect } from 'utils/analyticsUtils';

/** Query param used by Dev Bar "Quick Join" when logged in; sign out runs here so user lands on /join instead of /login. */
export const DEVBAR_LOGOUT_PARAM = 'devbar_logout';

/** Query param to open Quick Join modal on /join (e.g. after devbar logout redirect). */
export const DEVBAR_OPEN_QUICK_JOIN_PARAM = 'open_quick_join';

export default function signupLoader(queryClient) {
    return async ({ request }) => {
        const url = new URL(request.url);
        if (!getIsProduction() && url.searchParams.get(DEVBAR_LOGOUT_PARAM) === '1') {
            try {
                await Auth.signOut();
                return redirect(`/join?${DEVBAR_OPEN_QUICK_JOIN_PARAM}=1`);
            } catch {
                // Fall through to normal loader flow if signOut fails
            }
        }

        let authUser;
        try {
            authUser = await Auth.currentAuthenticatedUser();
        } catch {
            authUser = null;
        }

        const account = authUser
            ? await queryClient.ensureQueryData({
                  queryKey: [ACCOUNT_QUERY_KEY, authUser?.username],
                  queryFn: accountQueryFn,
              })
            : null;

        if (account?.subStatus && account?.subStatus !== 'NONE') {
            trackExistingUserRedirect({ destination: '/account' });
            return redirect('/account');
        }

        return null;
    };
}
